<svg-wrapper
  *ngIf="!isIconShown; else iconShown"
  class="user-icon wrapper"
  [bgColor]="bgColor"
  [buttonBorder]="buttonBorder"
  [iconColor]="iconColor"
  [initials]="initials"
  [size]="wrapperSize"
  [e2e]="e2e + '__avatar'"
></svg-wrapper>

<ng-template #iconShown>
  <svg-wrapper
    class="user-icon"
    [bgColor]="bgColor"
    [buttonBorder]="buttonBorder"
    [iconColor]="iconColor"
    [iconName]="iconName"
    [size]="wrapperSize"
    [e2e]="e2e + '__avatar'"
  ></svg-wrapper>
</ng-template>

<svg-wrapper
  *ngIf="isAdmin"
  class="admin-icon"
  [buttonBorder]="buttonBorder"
  bgColor="admin-icon--bg"
  iconColor="admin-icon--color"
  iconName="crown"
  size="small"
  [e2e]="e2e + '__avatar'"
></svg-wrapper>
